export default __webpack_public_path__ + "static/media/Ieb.a8a443d0.jpg";